'use client';

import { useEffect } from 'react';

const isDevelopment = process.env.NEXT_PUBLIC_APP_ENV === 'development';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <html>
      <body>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f9fafb',
          padding: '1rem',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}>
          <div style={{ maxWidth: '42rem', width: '100%' }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '0.5rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '2rem',
            }}>
              <h1 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#111827',
                marginBottom: '1rem',
              }}>
                Something went wrong
              </h1>

              {isDevelopment ? (
                <div>
                  <div style={{
                    backgroundColor: '#fef2f2',
                    border: '1px solid #fecaca',
                    borderRadius: '0.375rem',
                    padding: '1rem',
                    marginBottom: '1rem',
                  }}>
                    <h2 style={{
                      fontSize: '1.125rem',
                      fontWeight: '600',
                      color: '#991b1b',
                      marginBottom: '0.5rem',
                    }}>
                      {error.name}: {error.message}
                    </h2>
                    {error.digest && (
                      <p style={{
                        fontSize: '0.875rem',
                        color: '#dc2626',
                        marginBottom: '0.5rem',
                      }}>
                        Digest: {error.digest}
                      </p>
                    )}
                    {error.stack && (
                      <pre style={{
                        fontSize: '0.75rem',
                        color: '#b91c1c',
                        overflow: 'auto',
                        whiteSpace: 'pre-wrap',
                        backgroundColor: '#fee2e2',
                        padding: '0.75rem',
                        borderRadius: '0.25rem',
                        margin: 0,
                      }}>
                        {error.stack}
                      </pre>
                    )}
                  </div>
                  <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                    Debug mode enabled (APP_ENV=development)
                  </p>
                </div>
              ) : (
                <p style={{ color: '#4b5563', marginBottom: '1.5rem' }}>
                  A critical error occurred. Please refresh the page or contact support.
                </p>
              )}

              <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
                <button
                  onClick={reset}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: '#2563eb',
                    color: 'white',
                    borderRadius: '0.375rem',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                  }}
                >
                  Try again
                </button>
                <button
                  onClick={() => window.location.href = '/'}
                  style={{
                    padding: '0.5rem 1rem',
                    backgroundColor: '#e5e7eb',
                    color: '#1f2937',
                    borderRadius: '0.375rem',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                  }}
                >
                  Go home
                </button>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
